import axiosInstance from "./axios";

export const GetUser = () => {
  return axiosInstance.get("/auth/user");
};

export const SignIn = (data) => {
  return axiosInstance.post("/auth/login", data);
};
